import createIcon from '../../createIcon';

/**
 * @component @name Egg
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0M4LjUgMyA1IDkuMzMgNSAxNEM1IDE3Ljg3IDguMTMgMjEgMTIgMjFDMTUuODcgMjEgMTkgMTcuODcgMTkgMTRDMTkgOS4zMyAxNS41IDMgMTIgM1pNMTMgMThDMTAgMTggOCAxNi4wMSA4IDEzQzggMTIuNDUgOC40NSAxMiA5IDEyQzkuNTUgMTIgMTAgMTIuNDUgMTAgMTNDMTAgMTUuOTIgMTIuNDIgMTYgMTMgMTZDMTMuNTUgMTYgMTQgMTYuNDUgMTQgMTdDMTQgMTcuNTUgMTMuNTUgMTggMTMgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Egg = createIcon('Egg', [
  [
    'path',
    {
      d: 'M12 3C8.5 3 5 9.33 5 14C5 17.87 8.13 21 12 21C15.87 21 19 17.87 19 14C19 9.33 15.5 3 12 3ZM13 18C10 18 8 16.01 8 13C8 12.45 8.45 12 9 12C9.55 12 10 12.45 10 13C10 15.92 12.42 16 13 16C13.55 16 14 16.45 14 17C14 17.55 13.55 18 13 18Z',
      key: 'trn9o2',
    },
  ],
]);

export default Egg;
